import findIndex from 'lodash/findIndex';
import remove from 'lodash/remove';
import { EventBus } from 'utils/event-bus';
import Vue from 'vue';

import {
  SET_COURSES,
  SET_NEW_COURSE,
  SET_COURSE_LOADING,
  SET_COURSE_DETAIL,
  DELETE_USER_FROM_COURSE,
  DELETE_RT,
  CREATE_RT,
  EDIT_ACTIVITY_IN_COURSE_STATE,
  DELETE_DISCUSSION,
  REMOVE_STUDENTS_FROM_COURSE,
  UPDATE_COURSE_DETAIL,
  DELETE_COURSE,
  ARCHIVE_COURSE,
  PUBLISH_RT_IN_COURSE_STATE,
  PUBLISH_LD_IN_COURSE_STATE,
  SET_NEW_LIVE_DISCUSSION,
  SET_NEW_ONLINE_ROUNDTABLE,
  ADD_STUDENT_TO_COURSE,
  CHANGE_FULL_SCREEN_ON_COURSE_LAYOUT,
  UPDATE_SUBSCRIPTION_TO_COURSE,
  SET_DASHBOARD_ROLE,
  SHOW_SLIDING_HIDDEN_ROUNDTABLE_LIST,
  MARK_LIVE_DISCUSSION_AS_PUBLISHED,
  MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED,
  UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION,
  UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION,
  IMPORT_SAVED_FEEDBACK_ONLINE_DISCUSSION,
  IMPORT_SAVED_FEEDBACK_LIVE_DISCUSSION,
  DELETE_SAVED_FEEDBACK_ONLINE_DISCUSSION,
  DELETE_SAVED_FEEDBACK_LIVE_DISCUSSION,
  ENDED_RT_IN_COURSE_STATE,
  TOOGLE_COURSE_CHAT,
  UPDATE_RT_END_DATE_IN_COURSE_STATE,
  ACTIVE_RT_IN_COURSE_STATE,
  SYNC_COURSES,
  SEND_CHAT_MESSAGE,
  DELETE_CHAT_MESSAGE,
  DELETE_ALL_CHAT_MESSAGES,
  READ_COURSE_MESSAGES,
  UPDATE_COURSE_INTEGRATIONS,
  UPDATE_COURSES_LIST,
  UPDATE_SEQUENCE_DETAILS,
  SET_INSTRUCTOR_COURSES,
  SET_PARTICIPANT_COURSES,
  DELETE_DRAFT,
} from './../../mutation-types';

export default {
  [CHANGE_FULL_SCREEN_ON_COURSE_LAYOUT](state, changeToFullScreen) {
    state.fullScreen = changeToFullScreen;
    return state;
  },
  [ADD_STUDENT_TO_COURSE](state, user) {
    const users_ids = state.courseDetail.users.map((u) => u.id);
    if (!users_ids.includes(user.id)) state.courseDetail.users.push(user);
    return state;
  },
  [REMOVE_STUDENTS_FROM_COURSE](state, deleted) {
    const users = [...state.courseDetail.users];
    // Remove users from the state that were deleted from the request;
    remove(users, (u) => deleted.includes(u.id));
    state.courseDetail.users = users;
    return state;
  },
  [SET_COURSES](state, courseArray) {
    state.courseList = courseArray;
    return state;
  },
  [SET_INSTRUCTOR_COURSES](state, { courses, courses_count }) {
    state.instructor_courses = courses;
    state.total_instructor_courses = courses_count;
    return state;
  },
  [SET_PARTICIPANT_COURSES](state, { courses, courses_count }) {
    state.participant_courses = courses;
    state.total_participant_courses = courses_count;
    return state;
  },
  [SET_NEW_COURSE](state, course) {
    state.courseList.unshift(course);
    return state;
  },
  [SET_COURSE_LOADING](state, status) {
    state.loading = status;
    return state;
  },
  [SET_COURSE_DETAIL](state, courseDetailObj) {
    // if dispatched from settings:
    if (courseDetailObj.source && courseDetailObj.source === 'settings') {
      state.courseDetail.title = courseDetailObj.title;
      state.courseDetail.sections = courseDetailObj.sections;
      state.courseDetail.school_id = courseDetailObj.school_id;
      return state;
    }
    state.courseDetail = courseDetailObj;
    return state;
  },
  // PREFER UPDATE_COURSE_DETAIL OVER SET_COURSE_DETAIL, Need to start phasing it out
  [UPDATE_COURSE_DETAIL](state, newDetails) {
    let details = state.courseDetail;
    details = Object.assign(details, newDetails);
    state.courseDetail = details;
    return state;
  },
  [DELETE_COURSE](state, id) {
    const index = findIndex(state.courseList, { id });
    state.courseList.splice(index, 1);
    return state;
  },
  [ARCHIVE_COURSE](state, id) {
    const index = findIndex(state.courseList, { id });
    if (index >= 0) {
      const course = state.courseList[index];
      course.is_archived = !course.is_archived;
      const message = course.is_archived
        ? 'Course Archived'
        : 'Course Restored';
      EventBus.$emit('toast-msg', message);
    }
    return state;
  },
  [DELETE_USER_FROM_COURSE](state, user_id) {
    const index = state.courseDetail.users.findIndex(
      (user) => user.id === user_id
    );
    if (index !== -1) {
      state.courseDetail.users.splice(index, 1);
    }
    return state;
  },
  [DELETE_RT](state, id) {
    const index = findIndex(state.courseDetail.roundtables, { id });
    if (index !== -1) {
      state.courseDetail.roundtables.splice(index, 1);
    }
    return state;
  },
  [DELETE_DRAFT](state, id) {
    const index = findIndex(state.courseDetail.drafts, {id});
    if (index !== -1) {
      state.courseDetail.drafts.splice(index, 1);
    }
    return state;
  },
  [CREATE_RT](state, roundtable) {
    // Check if the creation is happening to the same course and only mutates true
    if (state.courseDetail.id === roundtable.course_id) {
      state.courseDetail.roundtables.push(roundtable);
      return state;
    }
    return state;
  },
  [DELETE_DISCUSSION](state, id) {
    const index = findIndex(state.courseDetail.live_discussions, { id });
    if (index !== -1) {
      state.courseDetail.live_discussions.splice(index, 1);
    }
    return state;
  },
  [SYNC_COURSES](state, payload) {
    const courses_ids = payload.map(course => course.id);
    if (courses_ids.length) {
      if (courses_ids.includes(state.courseDetail.id)) {
        Vue.set(state.courseDetail, 'school_id', payload[0].school_id);
      }
    }
    return state;
  },
  [PUBLISH_RT_IN_COURSE_STATE](state, roundtableID) {
    const { roundtables } = state.courseDetail;
    const index = findIndex(roundtables, { id: roundtableID });
    if (index !== -1) {
      roundtables[index].is_published = true;
    }
    return state;
  },
  [PUBLISH_LD_IN_COURSE_STATE](state, liveID) {
    const { live_discussions } = state.courseDetail;
    const index = findIndex(live_discussions, { id: liveID });
    if (index !== -1) {
      live_discussions[index].is_published = true;
    }
    return state;
  },
  [ENDED_RT_IN_COURSE_STATE](state, roundtableID) {
    const { roundtables } = state.courseDetail;
    const index = findIndex(roundtables, { id: roundtableID });
    if (index !== -1) {
      roundtables[index].is_ended = true;
    }
    return state;
  },
  [UPDATE_RT_END_DATE_IN_COURSE_STATE](state, roundtable) {
    const { roundtables } = state.courseDetail;
    const index = findIndex(roundtables, { id: roundtable.id });
    if (index !== -1) {
      roundtables[index].end_date = roundtable.end_date;
      roundtables[index].hard_close = roundtable.hard_close;
    }
    return state;
  },
  [ACTIVE_RT_IN_COURSE_STATE](state, roundtableID) {
    const { roundtables } = state.courseDetail;
    const index = findIndex(roundtables, { id: roundtableID });
    if (index !== -1) {
      roundtables[index].is_ended = false;
    }
    return state;
  },
  [EDIT_ACTIVITY_IN_COURSE_STATE](state, payload) {
    // payload needs id key (which is activity id)
    // const courseIndex = findIndex(state.courseList, { id: state.courseDetail.id });
    // const course = state.courseList[courseIndex];
    const { roundtables, live_discussions } = state.courseDetail;
    const rtIndex = findIndex(roundtables, { id: payload.id });
    if (rtIndex !== -1) {
      const updatedRT = { ...roundtables[rtIndex], ...payload };
      if (payload.points_settings && payload.points_settings.length) {
        updatedRT.points_settings = { peer_rewards: payload.points_settings };
      }
      // Filter out any null / undefined / falsy values from the points array
      state.courseDetail.roundtables.splice(rtIndex, 1, updatedRT);
    }
    const liveIndex = findIndex(live_discussions, { id: payload.id });
    if (liveIndex !== -1) {
      const updatedLive = { ...live_discussions[liveIndex], ...payload };
      state.courseDetail.live_discussions.splice(liveIndex, 1, updatedLive);
    }
    return state;
  },
  [SET_NEW_LIVE_DISCUSSION](state, payload) {
    const discussion_ids = state.courseDetail.live_discussions.map(
      (discussion) => discussion.id
    );
    if (
      !discussion_ids.includes(payload.id) &&
      payload.course_id === state.courseDetail.id
    ) {
      state.courseDetail.live_discussions.push(payload);
    }
    return state;
  },
  [SET_NEW_ONLINE_ROUNDTABLE](state, payload) {
    const roundtable_ids = state.courseDetail.roundtables.map(
      (discussion) => discussion.id
    );
    if (
      !roundtable_ids.includes(payload.id) &&
      payload.course_id === state.courseDetail.id
    ) {
      state.courseDetail.roundtables.push(payload);
    }
    return state;
  },
  [MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED](state, roundtable_id) {
    if (
      state.courseDetail &&
      state.courseDetail.roundtables &&
      state.courseDetail.roundtables.length
    ) {
      const online_roundtable = state.courseDetail.roundtables.find(
        (rt) => rt.id === roundtable_id
      );

      if (online_roundtable) {
        online_roundtable.is_published = true;
      }
    }

    return state;
  },
  [SET_DASHBOARD_ROLE](state, role) {
    state.dashboard_role = role;
    return state;
  },
  [UPDATE_SUBSCRIPTION_TO_COURSE](state, subscription) {
    if (state.dashboard_role === 'teacher') {
      const subscription_id = subscription.id;
      if (subscription.is_pinned === true) {
        const index = state.instructor_courses.findIndex(sub => sub.id === subscription_id);
        if (index !== -1) {
          const subs = state.instructor_courses.splice(index, 1)[0];
          subs.is_pinned = subscription.is_pinned;
          state.instructor_courses.unshift(subs);
        }
        return state;
      }
      if (subscription.is_pinned === false) {
        const sub = state.instructor_courses.find(sub => sub.id === subscription_id);
        if (sub) {
          sub.is_pinned = false;
          state.instructor_courses.sort((a, b) => {
            if (b.is_pinned && !a.is_pinned) {
              return 1;
            }
            if (!b.is_pinned && a.is_pinned) {
              return -1;
            }
            return new Date(b.created_at) - new Date(a.created_at);
          });
        }
        return state;
      }    
    }
    if (state.dashboard_role === 'student') {
      if (subscription.is_pinned === true) {
        const subscription_id = subscription.id;
        const index = state.participant_courses.findIndex(sub => sub.id === subscription_id);
        if (index !== -1) {
          const subs = state.participant_courses.splice(index, 1)[0];
          subs.is_pinned = subscription.is_pinned;
          state.participant_courses.unshift(subs);
        }
        return state;
      }    
    }
  },
  [SHOW_SLIDING_HIDDEN_ROUNDTABLE_LIST](state, status) {
    state.showSlidingRoundtableList = status;
    return state;
  },
  [MARK_LIVE_DISCUSSION_AS_PUBLISHED](state, live_discussion_id) {
    if (
      state.courseDetail &&
      state.courseDetail.live_discussions &&
      state.courseDetail.live_discussions.length
    ) {
      const live_discussion = state.courseDetail.live_discussions.find(
        (ld) => ld.id === live_discussion_id
      );

      if (live_discussion) {
        live_discussion.is_published = true;
      }
    }

    return state;
  },
  [UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION](state, payload) {
    if (payload.isEdit) {
      state.courseDetail.saved_live_feedback.forEach((c) => {
        if (c.id === payload.data.id) {
          c.text = payload.data.text;
          return c;
        }
      });
    } else {
      state.courseDetail.saved_live_feedback.push(payload.data);
    }
    return state;
  },
  [UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION](state, payload) {
    if (payload.isEdit) {
      state.courseDetail.saved_online_feedback.forEach((c) => {
        if (c.id === payload.data.id) {
          c.text = payload.data.text;
          return c;
        }
      });
    } else {
      state.courseDetail.saved_online_feedback.push(payload.data);
    }
    return state;
  },
  [IMPORT_SAVED_FEEDBACK_ONLINE_DISCUSSION](state, payload) {
    payload.forEach((c) => {
      state.courseDetail.saved_online_feedback.push({ id: c.id, text: c.text });
    });
    return state;
  },
  [IMPORT_SAVED_FEEDBACK_LIVE_DISCUSSION](state, payload) {
    payload.forEach((c) => {
      state.courseDetail.saved_live_feedback.push({ id: c.id, text: c.text });
    });
    return state;
  },
  [DELETE_SAVED_FEEDBACK_ONLINE_DISCUSSION](state, feedback_id) {
    const index = state.courseDetail.saved_online_feedback.findIndex(
      (sof) => sof.id === feedback_id
    );
    if (index !== -1) {
      state.courseDetail.saved_online_feedback.splice(index, 1);
    }
    return state;
  },
  [DELETE_SAVED_FEEDBACK_LIVE_DISCUSSION](state, feedback_id) {
    const index = state.courseDetail.saved_live_feedback.findIndex(
      (slf) => slf.id === feedback_id
    );
    if (index !== -1) {
      state.courseDetail.saved_live_feedback.splice(index, 1);
    }
    return state;
  },
  [TOOGLE_COURSE_CHAT](state) {
    state.courseDetail.chat_is_enabled = !state.courseDetail.chat_is_enabled;
    return state;
  },
  [SEND_CHAT_MESSAGE](state, payload) {
    EventBus.$emit('message-received', payload);
    return state;
  },
  [DELETE_CHAT_MESSAGE](state, id) {
    EventBus.$emit('message-deleted', id);
    return state;
  },
  [DELETE_ALL_CHAT_MESSAGES](state, array) {
    EventBus.$emit('all-messages-deleted', array);
    return state;
  },
  [READ_COURSE_MESSAGES](state) {
    state.courseDetail.unread_messages = 0;
    return state;
  },
  [UPDATE_COURSE_INTEGRATIONS](state, integration_id) {
    const index = state.courseDetail.edlink_integrations.findIndex(edl => edl.id === integration_id);
    if (index !== -1) {
      state.courseDetail.edlink_integrations.splice(index, 1);
    }
    return state;
  },
  [UPDATE_COURSES_LIST](state, courseUpdated) {
    let course = state.courseList.find(
      (course) => course.id === courseUpdated.id
    );
    if (course) {
      course.title = courseUpdated.title;
      course.sections = courseUpdated.sections;
    }
    return state;
  },
  [UPDATE_SEQUENCE_DETAILS](state, sequenceUpdated) {
    if (
      state.courseDetail &&
      state.courseDetail.sequences &&
      state.courseDetail.sequences.length
    ) {
      const sequence = state.courseDetail.sequences.find(
        (s) => s.id === sequenceUpdated.data.id
      );

      if (sequence) {
        sequence.title = sequenceUpdated.data.title;
      }
    }
    return state;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/courses/mutations.js